<form [formGroup]="formGroup" class="opportunity-tab-timeline-body">
  <div class="opportunity-tab-timeline-infos">
    <div class="opportunity-tab-timeline-input">
      <mat-form-field class="opportunity-tab-timeline-input-form-field">
        <mat-label>Current Stage</mat-label>
        <label>
          <input matInput readonly [value]="stageToLabel[activeStage]">
        </label>
      </mat-form-field>
      <mat-icon class="tooltip-icon" svgIcon="tooltip" matTooltipPosition="above"
                matTooltip="The current stage that the Divestment Project is within is automatically calculated
                by the completion of the milestones in the Timeline. The stages are: Non-Binding Offer; Binding Offer;
                Contracting; and Complete.">
      </mat-icon>
    </div>

    <div class="opportunity-tab-timeline-input">
      <mat-form-field class="opportunity-tab-timeline-input-form-field">
        <mat-label>Currently working to achieve Milestone</mat-label>
        <label>
          <input matInput readonly [value]="milestoneTitle[activeMilestoneId]">
        </label>
      </mat-form-field>
      <mat-icon class="tooltip-icon" svgIcon="tooltip" matTooltipPosition="above"
                matTooltip="The milestone that is the next one to be completed in the Timeline.
                This value is automatically calculated by using the completion of the milestones in the Timeline.
                The milestones are: Steer Co Decision to Proceed; NBO Approval; NBO Submission;
                BO Approval; BO Submission; Contracts Signed and Complete.">
      </mat-icon>
    </div>

    <div id="approach-type" class="opportunity-tab-timeline-input"
         [ngClass]="{'opportunity-tab-timeline-changed': isApproachTypeDirty()}"
         matTooltipPosition="below"
         matTooltip="{{getReadOnlyReason('approachType')}}">
      <div>Type of {{getTypeLabel(entry.type)}} Approach</div>
      <div id="slider">
        <digires-slide-toggle
          [formGroup]="formGroup"
          formCtrlName="approachType"
          [disabled]="isReadOnly('approachType')"
        >
          <span before>Flexible & Informal</span>
          <span>Fixed & Formal</span>
        </digires-slide-toggle>
        <mat-icon class="tooltip-icon" svgIcon="tooltip" matTooltipPosition="above"
                  matTooltip="The type of approach that is being pursued in relation to this Divestment Project.
                  The options are:  Flexible & Informal; Fixed & Formal. &quot;Flexible & Informal&quot; relates to an
                  'organic' opportunity where the discussions that have come about with the seller are not bound to any
                  rigid timetable or stringent conditions. &quot;Fixed & Formal&quot; relates to tender approach driven
                  by the seller where the timescales and submission requirements are bound to a rigid timetable and
                  stringent conditions.">
        </mat-icon>
      </div>
    </div>

  </div>

  <div class="opportunity-tab-timeline-grid">

    <div *ngFor="let stage of allStages" class="opportunity-tab-timeline-stage">

      <div class="opportunity-tab-timeline-stage-inner">
        <div *ngIf="stage === activeStage">

          <svg width="40" height="80" viewBox="0 0 40 80" fill="none" xmlns="http://www.w3.org/2000/svg"
               focusable="false" preserveAspectRatio="none">
            <path d="M0 0H40V80H0L35 39.5L0 0Z" fill="#3ED8C3"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M37.6576 39.4835L4.37175 78H40V2H4.44433L37.6576 39.4835ZM0 0H40V80H0L35 39.5L0 0Z"
                  fill="#1D4477"/>
          </svg>
          <svg id="body" width="220" height="80" viewBox="0 0 220 80" fill="none" xmlns="http://www.w3.org/2000/svg"
               focusable="false" preserveAspectRatio="none">
            <rect width="220" height="80" fill="#3ED8C3"/>
            <rect width="220" height="2" fill="#1D4477"/>
            <rect y="78" width="220" height="2" fill="#1D4477"/>
          </svg>
          <svg width="40" height="80" viewBox="0 0 40 80" fill="none" xmlns="http://www.w3.org/2000/svg"
               focusable="false" preserveAspectRatio="none">
            <path d="M40 39.5L5 0H0V80H5L40 39.5Z" fill="#3ED8C3"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M4.09998 2H0V78H4.08504L37.3424 39.5165L4.09998 2ZM40 39.5L5 0H0V80H5L40 39.5Z" fill="#1D4477"/>
          </svg>

        </div>
        <div *ngIf="stage !== activeStage">
          <svg width="40" height="80" viewBox="0 0 40 80" fill="none" xmlns="http://www.w3.org/2000/svg"
               focusable="false" preserveAspectRatio="none">
            <path d="M0 0H40V80H0L35 39.5L0 0Z" fill="#D3E9FA"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M37.6576 39.4835L4.37175 78H40V2H4.44433L37.6576 39.4835ZM0 0H40V80H0L35 39.5L0 0Z"
                  fill="#1D4477"/>
          </svg>
          <svg id="body" width="220" height="80" viewBox="0 0 220 80" fill="none" xmlns="http://www.w3.org/2000/svg"
               focusable="false" preserveAspectRatio="none">
            <rect width="220" height="80" fill="#D3E9FA"/>
            <rect width="220" height="2" fill="#1D4477"/>
            <rect y="78" width="220" height="2" fill="#1D4477"/>
          </svg>
          <svg width="40" height="80" viewBox="0 0 40 80" fill="none" xmlns="http://www.w3.org/2000/svg"
               focusable="false" preserveAspectRatio="none">
            <path d="M40 39.5L5 0H0V80H5L40 39.5Z" fill="#D3E9FA"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M4.09998 2H0V78H4.08504L37.3424 39.5165L4.09998 2ZM40 39.5L5 0H0V80H5L40 39.5Z" fill="#1D4477"/>
          </svg>

        </div>
        <span>
          <span [ngClass]="{'opportunity-tab-timeline-stage-text-current': stage === activeStage,
                            'opportunity-tab-timeline-stage-text-not-current': stage !== activeStage}">
            {{stageToLabel[stage]}}
          </span>
        </span>
      </div>

      <div class="opportunity-tab-timeline-stage-content"
           [ngClass]="{'opportunity-tab-timeline-stage-content-current': stage === activeStage}">
        <ng-container *ngIf="stage === lastTimelineStage">
          <digires-divestment-end-of-process *ngFor="let msId of stageToMilestoneIds[stage]"
                                             [readonly]="readonly"
                                             [formGroup]="formGroup"
                                             [activeMilestoneId]="activeMilestoneId"
                                             milestoneId="{{msId}}"
                                             (onChange)="onMilestoneChange()"
          ></digires-divestment-end-of-process>
        </ng-container>
        <ng-container *ngIf="stage !== lastTimelineStage">
          <digires-divestment-milestone *ngFor="let msId of stageToMilestoneIds[stage]"
                                        [readonly]="readonly"
                                        [formGroup]="formGroup"
                                        [activeMilestoneId]="activeMilestoneId"
                                        milestoneId="{{msId}}"
                                        (onChange)="onMilestoneChange()"
          ></digires-divestment-milestone>
        </ng-container>
      </div>

    </div>

  </div>

  <div class="opportunity-tab-timeline-comments">

    <div class="opportunity-tab-timeline-comment-box opportunity-tab-timeline-comment-box-active">

      <span class="tooltip">
        You can leave comments here to document the divestment process should you wish to.
      </span>

      <mat-form-field class="comment-input">
        <mat-label>General Comment</mat-label>
        <label>
          <textarea matInput type="text" formControlName="comment"
                    rows="8"
                    [ngClass]="{'opportunity-tab-timeline-changed': isCommentDirty()}"
                    [readonly]="isReadOnly('comment')"
                    matTooltipPosition="below"
                    matTooltip="{{getReadOnlyReason('comment')}}">
          </textarea>
        </label>
      </mat-form-field>

    </div>

    <div class="opportunity-tab-timeline-comment-box"
         [ngClass]="{
          'opportunity-tab-timeline-comment-box-active': isCompleted(),
          'opportunity-tab-timeline-comment-box-deactive': !isCompleted()
       }">

      <span class="tooltip">
        Please leave a comment after completing the End of Process.
      </span>

      <mat-form-field class="comment-input">
        <mat-label>End of Process Comment</mat-label>
        <label>
          <textarea matInput type="text" formControlName="timelineEndComment"
                    rows="8"
                    [ngClass]="{'opportunity-tab-timeline-changed': isEndOfProcessCommentDirty()}"
                    [readonly]="!isCompleted() || isReadOnly('timelineEndComment')"
                    matTooltipPosition="below"
                    matTooltip="{{getReadOnlyReason('timelineEndComment')}}">
          </textarea>
        </label>
      </mat-form-field>

    </div>
  </div>

</form>
